import styled from 'styled-components';

export const Half = styled.div`
  flex: 1 0 0;
`;
